export default theme => ({
    gallery: {
        position: 'relative',
        margin: '0 -8px !important',
        width: 'calc(100% + 16px)',
        '& li': {
            float: 'left',
            padding: '0 8px !important',
        }
    },
});